import React from 'react';

import Code from '../base';

const codestring = `const fetch = require('node-fetch');

const business_id = 'b897ce0c92eb30bf17632677d4000b3e';
const username = '131d905a-4adc-4415-aae8-999c3c3ed728';
const password = 'cO_PKTP5KZ5GsMa4lgXrR41lUVgDWje5ZDPWphrRPOs';

const url = \`https://b2b-api.lana-staging.xyz/business/\${business_id}/accounts\`;
const headers = {
    'Content-Type': 'application/json',
    'Authorization': 'Basic ' + Buffer.from(\`\${username}:\${password}\`).toString('base64'),
};

fetch(url, { headers: headers })
    .then(response => response.json())
    .then(data => {
        console.log(data)
    });`;

const NodeFetchAccounts = () => <Code language="javascript" codestring={codestring} />;

export default NodeFetchAccounts;
